const CHAVE='MB_LOGIN_APOS_SENHA';
// Somente o usuario, sem senha/token. Dado local de uso unico, valido por 5 minutos.
export function guardarUsuarioLogin(usuario) {
  try {if(typeof usuario==='string'&&usuario.length>0&&usuario.length<=255)sessionStorage.setItem(CHAVE,JSON.stringify({usuario,expira:Date.now()+300000}));} catch (_) {}
}
export function consumirUsuarioLogin() {
  try {
    const raw=sessionStorage.getItem(CHAVE);sessionStorage.removeItem(CHAVE);
    const dado=JSON.parse(raw||'null');
    return dado&&typeof dado.usuario==='string'&&dado.usuario.length<=255&&dado.expira>Date.now()?dado.usuario:'';
  } catch (_) {return '';}
}
